module.exports = __webpack_public_path__ + "static/media/06B.a2cfabaf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/robots/06B.png
// module id = 263
// module chunks = 0